export const TestIds = {
  fbPageEl: 'fb-page-element',
} as const;
